import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

export const generateExcelStatement = async (statement, data) => {
	console.log(data)
    // Create new workbook
	const workbook = new ExcelJS.Workbook();

	// Create sheet residue
	const sheet = workbook.addWorksheet('Residuos');

	// Define columns
	sheet.addRow([
		'ler',
		'rut establecimiento receptor',
		'código establecimiento receptor',
		'código tratamiento receptor',
		'cantidad',
		'gestión'
	]);

    // Add new rows by data residues
	data.map(row => {
		sheet.addRow([
			row.residue_LER,
            row.final_destination_rut,
            row.final_destination_code_sinader,
            row.treatment_code,
            row.sum_kilograms_total,
            row.management_code
		]);
	});

	// Generate buffer excel woorkbook
	const buffer = await workbook.xlsx.writeBuffer();

	// Create blob content excel
	const blob = new Blob([buffer], {
		type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
	});
	console.log('id statement???', statement)
	// Save blob file
	saveAs(blob, `planilla_declaracion_${statement.creation_date}.xlsx`);
};